import { render } from "./MobilePushPage.vue?vue&type=template&id=5d147de6"
import script from "./MobilePushPage.vue?vue&type=script&lang=js"
export * from "./MobilePushPage.vue?vue&type=script&lang=js"

import "./MobilePushPage.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__